// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipe-container {
    max-width: 1100px;
    margin: 0 auto;
    padding: 20px 0;
}

/* Header */
.recipe-header {
    display: flex;
    gap: 20px;
    margin-bottom: 25px;
    align-items: center;
}

.recipe-main-image {
    width: 320px;
    height: 220px;
    object-fit: cover;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
}

.recipe-info h1 {
    margin: 0 0 10px;
    font-size: 2rem;
}

.recipe-info p {
    margin: 4px 0;
    font-size: 1rem;
}

/* Ingrédients */
.ingredients-list {
    padding: 20px;
    list-style: none;
}

.ingredients-list li {
    padding: 8px 0;
    border-bottom: 1px solid rgba(0,0,0,0.08);
    font-size: 1rem;
}

/* Étapes */
.steps-list {
    padding: 20px;
}

.step-item {
    display: flex;
    gap: 20px;
    margin-bottom: 25px;
    align-items: flex-start;
}

.step-image {
    width: 180px;
    height: 140px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/*.step-text {*/
/*    display: flex;*/
/*    gap: 12px;*/
/*    align-items: flex-start;*/
/*}*/

.step-text {
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1 1;
}

.step-main {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}



.step-number {
    background: #6fb8af;
    color: white;
    min-width: 34px;
    min-height: 34px;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1;
    flex-shrink: 0;
}


.recipe-card {
    margin-bottom: 35px !important; /* espace entre Ingrédients et Étapes */
}

.ingredients-list,
.steps-list {
    padding: 24px 26px 30px;
}

.recipe-container .cards {
    display: block !important;
}

.step-list {
    margin: 0;
    padding-left: 18px;
}

.step-list li {
    margin-bottom: 6px;
    line-height: 1.4;
    font-size: 0.95rem;
}

.chef-tip {
    background: #f3f3f3; /* gris clair neutre */
    border-left: 4px solid #6fb8af; /* bleu moderne, changeable */
    padding: 12px 14px;
    margin-top: 12px;
    border-radius: 6px;
}

.chef-tip strong {
    font-size: 14px;
    color: #2a2a2a;
    margin-bottom: 6px;
    display: block;
}

.chef-tip p {
    margin: 0;
    color: #333; /* texte bien lisible */
    line-height: 1.4;
}


.chef-tip strong {
    display: block;
    margin-bottom: 6px;
    color: #6fb8af;
}

.dashboard.dark .chef-tip {
    background: #3a3a3a; /* fond sombre neutre */
    border-left: 4px solid #6fb8af; /* ta couleur principale */
    padding: 12px 14px;
    margin-top: 12px;
    border-radius: 6px;
}

.dashboard.dark .chef-tip strong {
    color: #6fb8af; /* accent identique au light mode */
}

.dashboard.dark .chef-tip p {
    color: #e6e6e6; /* texte clair mais pas blanc pur */
}


/* Dark mode */
.dashboard.dark .recipe-main-image,
.dashboard.dark .step-image {
    box-shadow: 0 4px 16px rgba(0,0,0,0.6);
}

.dashboard.dark .ingredients-list li {
    border-bottom-color: rgba(255,255,255,0.1);
}

.dashboard.dark .step-list li {
    color: #f1f1f1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/RecipePage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,eAAe;AACnB;;AAEA,WAAW;AACX;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA,eAAe;AACf,qBAAqB;AACrB,iBAAiB;AACjB,+BAA+B;AAC/B,IAAI;;AAEJ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;;;AAIA;IACI,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;;AAGA;IACI,8BAA8B,EAAE,uCAAuC;AAC3E;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB,EAAE,sBAAsB;IAC3C,8BAA8B,EAAE,6BAA6B;IAC7D,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,WAAW,EAAE,uBAAuB;IACpC,gBAAgB;AACpB;;;AAGA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB,EAAE,uBAAuB;IAC5C,8BAA8B,EAAE,0BAA0B;IAC1D,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc,EAAE,mCAAmC;AACvD;;AAEA;IACI,cAAc,EAAE,mCAAmC;AACvD;;;AAGA,cAAc;AACd;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".recipe-container {\r\n    max-width: 1100px;\r\n    margin: 0 auto;\r\n    padding: 20px 0;\r\n}\r\n\r\n/* Header */\r\n.recipe-header {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-bottom: 25px;\r\n    align-items: center;\r\n}\r\n\r\n.recipe-main-image {\r\n    width: 320px;\r\n    height: 220px;\r\n    object-fit: cover;\r\n    border-radius: 14px;\r\n    box-shadow: 0 4px 16px rgba(0,0,0,0.15);\r\n}\r\n\r\n.recipe-info h1 {\r\n    margin: 0 0 10px;\r\n    font-size: 2rem;\r\n}\r\n\r\n.recipe-info p {\r\n    margin: 4px 0;\r\n    font-size: 1rem;\r\n}\r\n\r\n/* Ingrédients */\r\n.ingredients-list {\r\n    padding: 20px;\r\n    list-style: none;\r\n}\r\n\r\n.ingredients-list li {\r\n    padding: 8px 0;\r\n    border-bottom: 1px solid rgba(0,0,0,0.08);\r\n    font-size: 1rem;\r\n}\r\n\r\n/* Étapes */\r\n.steps-list {\r\n    padding: 20px;\r\n}\r\n\r\n.step-item {\r\n    display: flex;\r\n    gap: 20px;\r\n    margin-bottom: 25px;\r\n    align-items: flex-start;\r\n}\r\n\r\n.step-image {\r\n    width: 180px;\r\n    height: 140px;\r\n    object-fit: cover;\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n}\r\n\r\n/*.step-text {*/\r\n/*    display: flex;*/\r\n/*    gap: 12px;*/\r\n/*    align-items: flex-start;*/\r\n/*}*/\r\n\r\n.step-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n    flex: 1;\r\n}\r\n\r\n.step-main {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n}\r\n\r\n\r\n\r\n.step-number {\r\n    background: #6fb8af;\r\n    color: white;\r\n    min-width: 34px;\r\n    min-height: 34px;\r\n    padding: 4px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: 700;\r\n    font-size: 1rem;\r\n    line-height: 1;\r\n    flex-shrink: 0;\r\n}\r\n\r\n\r\n.recipe-card {\r\n    margin-bottom: 35px !important; /* espace entre Ingrédients et Étapes */\r\n}\r\n\r\n.ingredients-list,\r\n.steps-list {\r\n    padding: 24px 26px 30px;\r\n}\r\n\r\n.recipe-container .cards {\r\n    display: block !important;\r\n}\r\n\r\n.step-list {\r\n    margin: 0;\r\n    padding-left: 18px;\r\n}\r\n\r\n.step-list li {\r\n    margin-bottom: 6px;\r\n    line-height: 1.4;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n.chef-tip {\r\n    background: #f3f3f3; /* gris clair neutre */\r\n    border-left: 4px solid #6fb8af; /* bleu moderne, changeable */\r\n    padding: 12px 14px;\r\n    margin-top: 12px;\r\n    border-radius: 6px;\r\n}\r\n\r\n.chef-tip strong {\r\n    font-size: 14px;\r\n    color: #2a2a2a;\r\n    margin-bottom: 6px;\r\n    display: block;\r\n}\r\n\r\n.chef-tip p {\r\n    margin: 0;\r\n    color: #333; /* texte bien lisible */\r\n    line-height: 1.4;\r\n}\r\n\r\n\r\n.chef-tip strong {\r\n    display: block;\r\n    margin-bottom: 6px;\r\n    color: #6fb8af;\r\n}\r\n\r\n.dashboard.dark .chef-tip {\r\n    background: #3a3a3a; /* fond sombre neutre */\r\n    border-left: 4px solid #6fb8af; /* ta couleur principale */\r\n    padding: 12px 14px;\r\n    margin-top: 12px;\r\n    border-radius: 6px;\r\n}\r\n\r\n.dashboard.dark .chef-tip strong {\r\n    color: #6fb8af; /* accent identique au light mode */\r\n}\r\n\r\n.dashboard.dark .chef-tip p {\r\n    color: #e6e6e6; /* texte clair mais pas blanc pur */\r\n}\r\n\r\n\r\n/* Dark mode */\r\n.dashboard.dark .recipe-main-image,\r\n.dashboard.dark .step-image {\r\n    box-shadow: 0 4px 16px rgba(0,0,0,0.6);\r\n}\r\n\r\n.dashboard.dark .ingredients-list li {\r\n    border-bottom-color: rgba(255,255,255,0.1);\r\n}\r\n\r\n.dashboard.dark .step-list li {\r\n    color: #f1f1f1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
